import { DefaultService } from '@/services/DefaultService';

export default class AtendimentoService extends DefaultService {


    save(obj) {
        return this._http.post(`${this._env}/atendimento`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(uuid) {
        return this._http.get(`${this._env}/atendimento/uuid/${uuid}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    finalize(obj) {
        return this._http.post(`${this._env}/atendimento/finalize`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(filtros, column = 'datahora', order = 'desc', page = 0, limit = 50, ...params) {
        return this._http.post(encodeURI(`${this._env}/atendimento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    uploadAttachment(uuid, form) {
        return this._http.post(`${this._env}/atendimento/${uuid}/attachment`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAttachments(uuid, column = 'datahora', order = 'desc', page = 0, limit = 20) {
        return this._http.get(`${this._env}/atendimento/${uuid}/attachments.json?page=${page}&limit=${limit}&column=${column}&order=${order}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    deleteAnexos(anexo) {
        return this._http.post(`${this._env}/atendimento/attachmentt/delete`, anexo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllByIdFunilAndIdEtapa(etapas) {
        return this._http.post(encodeURI(`${this._env}/ven/findAllByIdFunilAndIdEtapa/atendimento.json`), etapas, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/ven/atendimento/getcombo.json?param=${params}`), this._headers).then(res => {
				return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
		});
	}

    updateEtapaAtendimento(obj) {
        return this._http.post(`${this._env}/etapa/atendimento/update`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}